import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'

export const InputFormChangePassword: {
    input: InputBuildProps
    layout: LayoutProps
}[] = [
    {
        input: {
            id: 'nomeUsuario',
            label: 'Usuário ou e-mail',
            maxLength: 128,
            required: true
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'senhaAntiga',
            label: 'Senha atual',
            type: 'password',
            required: true,
            maxLength: 30
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'senhaNova',
            label: 'Nova senha',
            type: 'password',
            required: true,
            maxLength: 30
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'senhaNovaConfirmacao',
            label: 'Confirmar nova senha',
            type: 'password',
            required: true,
            maxLength: 30
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    }
]
